import React from 'react';
import PropTypes from 'prop-types';

// material-ui components
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/readOnlyFieldStyle';

const useStyles = makeStyles(styles);

export default function ReadOnlyField({ label, value, children }) {
	const classes = useStyles();

	return (
		<div className={classes.wrapper}>
			<div className={classes.label}>{label}</div>
			<div className={classes.value}>{value || children}</div>
		</div>
	);
}

ReadOnlyField.propTypes = {
	label: PropTypes.node.isRequired,
	value: PropTypes.any,
	children: PropTypes.any,
};
